/**
 * Polyfills for Angular.
 * Note: @angular/localize/init is declared in angular.json polyfills array.

/**
 * Polyfills for Angular.
 * Cleaned up — IE-era polyfills removed.
 */

(window as any).global = window;

import '@angular/compiler';

/***************************************************************************************************
 * Zone JS is required by default for Angular itself.
 */
import 'zone.js';
